import ModelsApi from '@/api/models';

const getInitialParams = () => ({
  skip: 0,
  limit: 100,
  search_string: null,
  only_deleted: false,
  order: {
    column: 'title',
    desc: true,
  },
});

export default {
  namespaced: true,

  state: {
    data: {},
    meta: {},
    loading: false,
    error: null,
    params: getInitialParams(),
  },

  actions: {
    async fetch(ctx) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        const response = await ModelsApi.fetch(ctx.getters.params);

        if (!response.cancelled) {
          ctx.commit('setData', response.data.data);
          ctx.commit('setMeta', response.data.meta);
          ctx.commit('setLoading', false);
        }
      } catch (err) {
        ctx.commit('setError', err);
        ctx.commit('setLoading', false);
      }
    },

    async create(ctx, data) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        const response = await ModelsApi.create(data);
        return null;
      } catch (err) {
        ctx.commit('setError', err);
        return err;
      } finally {
        await ctx.dispatch('fetch');
        ctx.commit('setLoading', false);
      }
    },

    async save(ctx, data) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        const response = await ModelsApi.update(data);
      } catch (err) {
        ctx.commit('setError', err);
      } finally {
        await ctx.dispatch('fetch');
        ctx.commit('setLoading', false);
      }
    },

    async remove(ctx, data) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        const response = await ModelsApi.remove(data);
        return null;
        ctx.commit('removeModel', data);
      } catch (err) {
        ctx.commit('setError', err);
        return err;
      } finally {
        await ctx.dispatch('fetch');
        ctx.commit('setLoading', false);
      }
    },
  },

  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },

    setError(state, err) {
      state.error = err;
    },

    setData(state, data) {
      state.data = data;
    },

    setMeta(state, meta) {
      state.meta = meta;
    },
  },

  getters: {
    loading: state => state.loading,
    list: state => (state.data.items ? state.data.items : []).sort((a, b) => {
      return a.title.localeCompare(b.title)
    }),
    error: state => state.error,
    params: (state, getters) => {
      return {
        ...state.params,
        search_string: getters.searchQuery,
        order_by: state.params.order.column,
        order_dir: state.params.order.desc ? 'desc' : 'asc',
      };
    },
    searchQuery: (state, getters, rootState, rootGetters) => rootGetters['util/searchQuery'],
  },
};
